import { render, staticRenderFns } from "./personality.vue?vue&type=template&id=39ee2805&scoped=true&"
import script from "./personality.vue?vue&type=script&lang=ts&"
export * from "./personality.vue?vue&type=script&lang=ts&"
import style0 from "./personality.vue?vue&type=style&index=0&id=39ee2805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ee2805",
  null
  
)

export default component.exports